module.exports = __webpack_public_path__ + "static/media/l-md8.3ca3bbcc.png";